import { render, staticRenderFns } from "./HeaderDropdownsStorage.vue?vue&type=template&id=d7a8c26a&"
import script from "./HeaderDropdownsStorage.vue?vue&type=script&lang=ts&"
export * from "./HeaderDropdownsStorage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports